export default {
  basemaps: [
    {
      id: 'light',
      name: 'Light',
      url: 'mapbox://styles/wetlands/ckjaa0lzb7nht19o5w267pfbm',
    },
    {
      id: 'satellite',
      name: 'Satellite',
      url: 'mapbox://styles/wetlands/ckjaaqt88i6l519qkmhmcuq3n',
    },
  ],
  selectedBasemap: 'light',
  lonLat: null,
  popUp: false,
};
